import { CopyClipboardButton } from "@/features/invoices/components/CopyClipboardButton";
import { cn } from "@/utils/cn";

interface CopyPayLinkButtonProps {
  url: string;
  className?: string;
}

export function CopyPayLinkButton({ url, className }: CopyPayLinkButtonProps) {
  return (
    <CopyClipboardButton
      text={url}
      className={cn("paylink-copy", className)}
    />
  );
}
